import React from 'react';

const WaveEnhanceIcon = (): React.ReactElement => (
    <svg
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="device-svg-icons"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M24 27C21.5147 27 19.5 29.0147 19.5 31.5C19.5 33.9853 21.5147 36 24 36C26.4853 36 28.5 33.9853 28.5 31.5C28.5 29.0147 26.4853 27 24 27ZM22.5 31.5C22.5 30.6716 23.1716 30 24 30C24.8284 30 25.5 30.6716 25.5 31.5C25.5 32.3284 24.8284 33 24 33C23.1716 33 22.5 32.3284 22.5 31.5Z"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M24 4.5C13.2304 4.5 4.5 13.2304 4.5 24C4.5 34.7696 13.2304 43.5 24 43.5C34.7696 43.5 43.5 34.7696 43.5 24C43.5 13.2304 34.7696 4.5 24 4.5ZM7.5 24C7.5 14.8873 14.8873 7.5 24 7.5C33.1127 7.5 40.5 14.8873 40.5 24C40.5 33.1127 33.1127 40.5 24 40.5C14.8873 40.5 7.5 33.1127 7.5 24Z"
        />
    </svg>
);

export default WaveEnhanceIcon;
